import {combineReducers} from 'redux';
import list from './championships/list';
import active from './championships/active';

export default combineReducers({
  list,
  active,
});



// WEBPACK FOOTER //
// ./src/reducers/app/championships.js